import { gql } from 'graphql.macro'
import PeriodFragment from '../../Periods/lib/PeriodFragment'
import ReadingTypeFragment from '../../ReadingTypes/lib/ReadingTypeFragment'
import ConditionThirdLayerFragment from '../../Conditions/lib/ConditionThirdLayerFragment'

export default gql`
  fragment TermSecondLayerFragment on Term {
    id
    type
    value

    period {
      ...PeriodFragment
    }

    readingType {
      ...ReadingTypeFragment
    }

    condition {
      ...ConditionThirdLayerFragment
    }
  }

  ${PeriodFragment}
  ${ReadingTypeFragment}
  ${ConditionThirdLayerFragment}
`
